// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"cart-handler","172":"list-handler"}[chunkId] + "." + {"105":"d14c7047","172":"0a347147"}[chunkId] + ".js";
};